import type { PaymentState } from "@/api/custom_types";
import { objectUtils } from "@/utils/object";
import { z } from "zod";
import type { PaymentMethodsKey } from "./paymentSentSearch.types";

const PAYMENT_STATUS: Record<PaymentState, PaymentState> = {
	accepted: "accepted",
	pending: "pending",
	rejected: "rejected",
};

const PAYMENT_METHODS: Record<PaymentMethodsKey, PaymentMethodsKey> = {
	market: "market",
	system: "system",
};

const PAYMENT_STATUS_ARR = objectUtils.toArray(PAYMENT_STATUS, "values");
const PAYMENT_METHODS_ARR = objectUtils.toArray(PAYMENT_METHODS, "values");

const schema = z.object({
	payment_type: z
		.enum([PAYMENT_METHODS.market, PAYMENT_METHODS.system])
		.optional(),
	username: z.string().optional(),
	statuses: z
		.enum([
			PAYMENT_STATUS.accepted,
			PAYMENT_STATUS.pending,
			PAYMENT_STATUS.rejected,
		])
		.optional(),
});

const PAYMENT_SENT_SEARCH_CONSTANTS = Object.freeze({
	PAYMENT_METHODS,
	PAYMENT_STATUS,
	PAYMENT_METHODS_ARR,
	PAYMENT_STATUS_ARR,
	schema,
});

export { PAYMENT_SENT_SEARCH_CONSTANTS };
